var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 15.5C6.0835 15.5 5.24322 15.2708 4.47933 14.8125C3.71544 14.3542 3.11127 13.75 2.66683 13H0.333496V11.3333H2.0835C2.04183 11.0139 2.01766 10.7394 2.011 10.51C2.00377 10.2811 2.00016 10 2.00016 9.66667H0.333496V8H2.00016C2.00016 7.625 2.00377 7.31583 2.011 7.0725C2.01766 6.82972 2.04183 6.58333 2.0835 6.33333H0.333496V4.66667H2.66683C2.86127 4.33333 3.08016 4.03111 3.3235 3.76C3.56627 3.48944 3.84739 3.25 4.16683 3.04167L2.8335 1.66667L4.00016 0.5L5.79183 2.29167C6.11127 2.18056 6.50711 2.125 6.97933 2.125C7.45155 2.125 7.84738 2.18056 8.16683 2.29167L10.0002 0.5L11.1668 1.66667L9.79183 3.04167C10.1113 3.25 10.3996 3.48944 10.6568 3.76C10.9135 4.03111 11.1391 4.33333 11.3335 4.66667H13.6668V6.33333H11.9168C11.9585 6.65278 11.9829 6.91667 11.9902 7.125C11.9968 7.33333 12.0002 7.625 12.0002 8H13.6668V9.66667H12.0002C12.0002 10 11.9968 10.2811 11.9902 10.51C11.9829 10.7394 11.9585 11.0139 11.9168 11.3333H13.6668V13H11.3335C10.8891 13.75 10.2849 14.3542 9.521 14.8125C8.75711 15.2708 7.91683 15.5 7.00016 15.5ZM5.3335 11.3333H8.66683V9.66667H5.3335V11.3333ZM5.3335 8H8.66683V6.33333H5.3335V8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue);
export default __webpack_public_path__ + "static/media/issue.0fad8502a306dbd063c56a45c107f703.svg";
export { ForwardRef as ReactComponent };